import { render, staticRenderFns } from "./Standings.vue?vue&type=template&id=1bb5cbbf&scoped=true&"
import script from "./Standings.vue?vue&type=script&lang=js&"
export * from "./Standings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb5cbbf",
  null
  
)

export default component.exports